export default {
  calendar: {
    title: "Regulatory calendar",
    subtitle: "The cycles that drive price and reimbursement in Spain, with their upcoming dates. Estimated ones are marked as such.",
    errorLabel: "Error:",
    daysDeadline: "days remaining",
    upcomingMilestones: "Upcoming milestones",
    loading: "Loading…",
    official: "Official",
    estimated: "Estimated",
    deadlineOpen: "Deadline open",
    today: "today",
    inDay: "in {n} day",
    inDays: "in {n} days",
    windowLabel: "Window:",
    recent: "Recent",
    closed: "Closed",
    // Expected milestones (R-22…R-26, §90 phase 3)
    predictionsTitle: "What is coming and what has not arrived",
    predictionsHint: "dates that affect you, and milestones past their window",
    predictionsEmpty: "Nothing here. Dates appear when an origin milestone with a known window occurs.",
    pred_cumplido: "Fulfilled",
    pred_cuenta_atras: "Countdown",
    pred_sin_llegar: "Not arrived",
    predAll: "All",
    predOwn: "Mine",
    predRival: "Competitors",
    predUsual: "usually {n} days · {m} so far",
    predUsualUnknown: "{m} days since origin",
    predHorizon: "Window",
    predHorizonMonths: "{n} months",
    predCountdownHint: "end of data exclusivity, market protection or orphan exclusivity, within the chosen window",
    predLateHint: "milestones a source should have confirmed and has not",
    predDoneHint: "arrived within the expected window",
    predPortfolio: "Portfolio",
    predCompetitor: "Competition",
    predLate: "{n} days late",
    predDoneOn: "Fulfilled on {date}",
    predOrigin: "After “{hito}” ({date})",
    predBasisLegal: "statutory deadline: {n} days",
    predBasisEmpirical: "empirical deadline: {n} days",
    // Publication windows (R-32 / C-07, §90 phase 4D)
    pubTitle: "Upcoming expected publications",
    pubHint: "When each body usually publishes. If a window passes with no new file we flag it: a silent source is not the same as no news.",
    pubOpen: "window open",
    pubMissing: "not published",
    pubOk: "published",
    pubNext: "Next window: {from} → {to}",
    pubMissingSince: "last window closed on {date} with no new file",
    monthsShort: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
  },
};
